import * as moment from "moment";
import Vue from "vue";

Vue.filter('moment', function(value: string | Date, format = 'DD.MM.YYYY') {  
    if (!value) {
      return '';
    }
    let date = value;
    if (!(date instanceof Date)) {
      date = new Date(date);
    }    
    moment.lang("ru");
    return moment(date).format(format);
})
// Vue.filter("moment", function(value: Date, format = "DD.MM.YYY") {
//   var now = moment(value);
//   moment.lang("ru");
//   return now.format(format);
// });


// WEBPACK FOOTER //
// ./scripts/filters/moment.ts